// extracted by mini-css-extract-plugin
export default {"manual":"project-manual_manual__Mx-fB"};